<template>
  <div>
    <a-tabs default-active-key="1">
      <a-tab-pane key="1"
                  tab="基本信息">
        <table class="fx-form-view">
          <col width="120px" />
          <col />
          <col width="120px" />
          <col />
          <col width="120px" />
          <col />
          <tr>
            <th>姓名</th>
            <td>
              {{ info.expertName }}
            </td>
            <th>出生年月</th>
            <td>
              {{ info.birthDate | dateFormat}}
            </td>
            <th>性别</th>
            <td>
              {{ info.gender == '1' ? '男' : '女' }}
            </td>
          </tr>
          <tr>
            <!--  <th>民族</th>
            <td>
              {{ info.national }}
            </td> -->
            <th>身份证号</th>
            <td>
              {{ info.idCard }}
            </td>
            <th>手机号码</th>
            <td>
              {{ info.mobilePhone }}
            </td>
            <th>紧急联系电话</th>
            <td>
              {{ info.emergencyMobilePhone }}
            </td>
          </tr>
          <tr>
            <th>电子邮箱</th>
            <td>
              {{ info.email }}
            </td>
            <th>所在行政区域</th>
            <td>
              {{ info.extras.areaAddressText }}
            </td>
            <th>联系地址</th>
            <td colspan="3">
              {{ info.address }}
            </td>
          </tr>
          <!--      <tr>
            <th>专家标签</th>
            <td colspan="5">
              <a-tag v-for="it in info.extras.tagInfos"
                     :key="it.id"
                     :title="it.tagDetail"
                     :color="it.tagColor">
                {{ it.tagName }}
              </a-tag>
              &nbsp;&nbsp;&nbsp;&nbsp;
              <a-space style="float: right"
                       v-if="isAdmin">
                <a class="link_blue"
                   type="primary"
                   @click="doSet(info.id, info.extras.tagIds)">设置</a>
                <a-divider type="vertical" />
                <a-popconfirm title="确认删除所有标签?"
                              ok-text="是"
                              cancel-text="否"
                              @confirm="onDelete(info.id)">
                  <a class="link_blue">重置</a>
                </a-popconfirm>
              </a-space>
            </td>
          </tr> -->
        </table>
      </a-tab-pane>
      <a-tab-pane key="2"
                  tab="工作信息">
        <table class="fx-form-view">
          <col width="150px" />
          <col />
          <tr>
            <th>是否在职</th>
            <td>
              {{ info.extras.incumbency}}
            </td>
            <th>工作单位全称</th>
            <td>
              {{ info.unitName }}
            </td>
          </tr>
          <tr>
            <th>当前工作单位性质</th>
            <td>
              {{ info.extras.unitProperties }}
            </td>
            <th>职务</th>
            <td>
              {{ info.position }}
            </td>
          </tr>
          <tr>
            <th>其他需回避的单位</th>
            <td>
              {{ info.avoidUnit }}
            </td>
          </tr>
        </table>
      </a-tab-pane>
      <a-tab-pane key="3"
                  tab="专业领域信息">
        <table class="fx-form-view">
          <col width="120px" />
          <col />
          <tr>
            <th>采购品目</th>
            <td colspan="5">
              {{ info.purchaseItem }}
            </td>
          </tr>
          <tr>
            <th>毕业学校</th>
            <td>
              {{ info.school }}
            </td>
            <th>最高学历</th>
            <td>
              {{ info.extras.educationName }}
            </td>
            <th>职称</th>
            <td>
              {{ info.extras.professionaltitle }}
            </td>
          </tr>
          <tr>
            <th>专业领域</th>
            <td colspan="5"
                v-html="info.academic"></td>
          </tr>
          <tr>
            <th>学术成果</th>
            <td colspan="5"
                v-html="info.majorResult"></td>
          </tr>
          <tr>
            <th>获得奖励</th>
            <td colspan="5"
                v-html="info.reward"></td>
          </tr>
        </table>
      </a-tab-pane>
      <a-tab-pane key="4"
                  tab="证明材料">
        <table class="fx-form-view">
          <col width="320px" />
          <col />
          <tr>
            <th>身份证扫描件</th>
            <td>
              <upload-index :readonly="true"
                            :referId='info.id'
                            configKey='expert.apply.idcard'
                            :zip-title="info.name + '的相关附件'" />
            </td>
          </tr>
          <tr>
            <th>学历证书/毕业证书</th>
            <td>
              <upload-index :readonly="true"
                            :referId='info.id'
                            configKey='expert.apply.diploma'
                            :zip-title="info.name + '的相关附件'" />
            </td>
          </tr>
          <tr>
            <th>专业技术职称证书</th>
            <td>
              <upload-index :readonly="true"
                            :referId='info.id'
                            configKey='expert.apply.technical'
                            :zip-title="info.name + '的相关附件'" />
            </td>
          </tr>
          <tr>
            <th>职业资格证书等其他资料</th>
            <td>
              <upload-index :readonly="true"
                            :referId='info.id'
                            configKey='expert.apply.professional'
                            :zip-title="info.name + '的相关附件'" />
            </td>
          </tr>
        </table>
      </a-tab-pane>
    </a-tabs>
  </div>
</template>

<script>

import UploadIndex from '@/components/selector/UploadIndex'
import DictCascader from '@/components/dict/DictCascader'

export default {
  name: 'ExpertApplyForView',
  components: {
    UploadIndex,
    DictCascader,
  },
  props: {
    info: {
      type: Object,
      default: () => {
        return { extras: {} }
      }
    },
  },
  data () {
    return {
      isAdmin: false,
      user: this.$ls.get('user'),
    }
  },
  computed: {},
  created () {
    this.isAdmin = (this.user.permissions['expert.info.manage'] || this.user.permissions['system.manage'])
  },
  methods: {
    onDelete (id) {
      this.$http.post('/api/1/expertmain/expert_tag/delTagExpert?expertId=' + id).then(resp => {
        this.delLoading = false
        if (resp.code !== 200) {
          this.$error({ content: '重置失败！' })
          return false
        }
        this.$message.success('重置成功')
        this.onSetSuccess(id)
      })
    },
    onSetSuccess () {
      this.$emit('success')
    },
    doSet (id, ids) {
      this.$refs.tagSetModal.onStartLoadData(id, ids)
    },
  }
}
</script>
